import { useOverlayActions } from '@store'
import { CurrencyRewardOverlayData } from '@store'

import { OverlayLayout } from '../OverlayLayout'
import styles from './CurrencyRewardOverlay.module.scss'
import { DiamondAnimation } from '@shared'
import { Icon, IconButton } from '@ds'
import { useTranslation } from 'react-i18next'



export const CurrencyRewardOverlay = ({
  amount,
  description,
  onClaim,
}: CurrencyRewardOverlayData['payload']) => {
  const { hideOverlay } = useOverlayActions()
  const { t } = useTranslation()

  const handleClaim = () => {
    onClaim?.()
    hideOverlay()
  }

  return (
    <OverlayLayout>
      <div className={styles.card}>
        <button className={styles.closeButton} onClick={hideOverlay}>
          <svg viewBox="0 0 20 20" fill="none">
            <line x1="3.8" y1="4.1" x2="15.9" y2="16.1" stroke="white" />
            <line x1="15.9" y1="3.9" x2="3.8" y2="15.9" stroke="white" />
          </svg>
        </button>


        <div className={styles.amountBlock}>
          <svg viewBox="0 0 199 183" fill="none" className={styles.diamond}>
            <DiamondAnimation optimized />
          </svg>
          <span className={styles.amount}>{amount}</span>
          <span className={styles.currency}>$NOT</span>
          <span className={styles.title}>Reward</span>

        </div>

       {description ? <div className={styles.textBlock}>

          <span className={styles.description}>
            {description}
          </span>
        </div> : null}

        <IconButton
          leftIcon={<Icon name="bow" size="M" className={styles.claimButtonIcon} />}
          onClick={handleClaim}
          className={styles.claimButton}
        >
          <span className={styles.claimLabel}>
            {t('promoCode.claimButton')}
          </span>
        </IconButton>

      </div>
    </OverlayLayout>
  )
}
